<template>
    <div class="contact-us">
        <img class="service-img" src="../../assets/black-logo.png">
        <div class="home-title">联系我们</div>
        <div class="contact-list-box">
            <div class="contact-list">
                <div>
                    <div class="contact-title">全国合作</div>
                    <div>qiufenghua@branew.com.cn</div>
                </div>
            </div>
            <div class="contact-list">
                <div>
                    <div class="contact-title">品牌/战略合作</div>
                    <div>linbaobao@branew.com.cn</div>
                </div>
            </div>
            <div class="contact-list">
                <div>
                    <div class="contact-title">大宗团单</div>
                   <div>fanjianpeng@branew.com.cn</div>
                </div>
            </div>
        </div>
        <div class="contact-list-box">
            <div class="contact-list">
                <div>
                    <div class="contact-title">人才招聘</div>
                    <div>zhaopin@branew.com.cn</div>
                </div>
            </div>
            <div class="contact-list">
                <div>
                    <div class="contact-title">官方服务热线</div>
                   <div>400-888-7090/010-65437788</div>
                   <div>（周一到周日8:00-21:00）</div>
                </div>
            </div>
            <div class="contact-list" @click="$router.push('/stores')">
                <div>
                    <div class="contact-title">附近门店</div>
                    <div>查找您附近的线下门店</div>
                    <div>立即前往 →</div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue';
import bus from '@/components/bus';

export default {
  name: 'Home',
  components: {
    HelloWorld,
  },
  data(){
    return {
    }
  },
  mounted(){
      bus.$emit('changeRoute', this.$route.path);
  },
  
}
</script>
<style scoped lang="scss">
.service-img{
  width: 1.5rem;
  height: 1.7rem;
  margin-top: 3rem;
}
.home-title{
  font-size: 2rem;
  margin: 1rem 0;
}
.contact-us{
    margin-bottom: 5rem;
}
.contact-list-box{
    padding: 2rem 12rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .contact-list{
        margin: 1rem 2rem;
        background: #fff;
        width: 25%;
        height: 11rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: all 0.6s;
    }
    .contact-list:hover{
        transform: scale(1.2);
    }

    .contact-title{
        font-weight: bolder;
        font-size: 1.3rem;
        margin-bottom: 1.3rem;
    }
}
</style>